// extracted by mini-css-extract-plugin
export default {"container":"_359Ex","qrCodeWrapper":"_36xXi","appSection":"C6n-Z","appImage":"HhrII","link":"_2jK_m","appLinkImage":"_4NIDL"};